import WhatWeDo from './what-we-do'
export default WhatWeDo